import React from 'react';
import { SsiFooter as Footer } from 'smartsuite-ui';
import { useLabelContext } from '../../shared/hooks/labelContext';
import { useFeatureTokenContext } from '../../shared/hooks/featureTokensContext';

export default function SsiFooter() {
    const { ssiLabels } = useLabelContext();
    const { ssiSystemFeature } = useFeatureTokenContext();

    if (!ssiSystemFeature?.footer) {
        return null;
    }

    return <Footer ssiLabels={ssiLabels} />;
}
